/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as ProtectedZonesRouteImport } from './routes/_protected/zones'
import { Route as ProtectedPaymentMethodsRouteImport } from './routes/_protected/payment-methods'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedCategoriesRouteImport } from './routes/_protected/categories'
import { Route as ProtectedWarehousesIndexRouteImport } from './routes/_protected/warehouses/index'
import { Route as ProtectedUsersIndexRouteImport } from './routes/_protected/users/index'
import { Route as ProtectedTenantsIndexRouteImport } from './routes/_protected/tenants/index'
import { Route as ProtectedSuppliersIndexRouteImport } from './routes/_protected/suppliers/index'
import { Route as ProtectedSellsIndexRouteImport } from './routes/_protected/sells/index'
import { Route as ProtectedIncomesIndexRouteImport } from './routes/_protected/incomes/index'
import { Route as ProtectedExpensesIndexRouteImport } from './routes/_protected/expenses/index'
import { Route as ProtectedClientsIndexRouteImport } from './routes/_protected/clients/index'
import { Route as ProtectedCashRegisterIndexRouteImport } from './routes/_protected/cash-register/index'
import { Route as ProtectedBuysIndexRouteImport } from './routes/_protected/buys/index'
import { Route as ProtectedBalancesIndexRouteImport } from './routes/_protected/balances/index'
import { Route as ProtectedArticlesIndexRouteImport } from './routes/_protected/articles/index'
import { Route as ProtectedAccountsIndexRouteImport } from './routes/_protected/accounts/index'
import { Route as ProtectedWarehousesIdRouteImport } from './routes/_protected/warehouses/$id'
import { Route as ProtectedUsersIdRouteImport } from './routes/_protected/users/$id'
import { Route as ProtectedTenantsIdRouteImport } from './routes/_protected/tenants/$id'
import { Route as ProtectedSuppliersIdRouteImport } from './routes/_protected/suppliers/$id'
import { Route as ProtectedSellsCreateRouteImport } from './routes/_protected/sells/create'
import { Route as ProtectedSellsIdRouteImport } from './routes/_protected/sells/$id'
import { Route as ProtectedIncomesIdRouteImport } from './routes/_protected/incomes/$id'
import { Route as ProtectedExpensesIdRouteImport } from './routes/_protected/expenses/$id'
import { Route as ProtectedClientsIdRouteImport } from './routes/_protected/clients/$id'
import { Route as ProtectedBuysCreateRouteImport } from './routes/_protected/buys/create'
import { Route as ProtectedBuysIdRouteImport } from './routes/_protected/buys/$id'
import { Route as ProtectedArticlesIdRouteImport } from './routes/_protected/articles/$id'
import { Route as ProtectedAccountsIdRouteImport } from './routes/_protected/accounts/$id'
import { Route as ProtectedLedgersSellsIndexRouteImport } from './routes/_protected/ledgers/sells/index'
import { Route as ProtectedLedgersCustomerDepositsIndexRouteImport } from './routes/_protected/ledgers/customer-deposits/index'
import { Route as ProtectedLedgersBuysIndexRouteImport } from './routes/_protected/ledgers/buys/index'
import { Route as ProtectedLedgersSellsIdRouteImport } from './routes/_protected/ledgers/sells/$id'
import { Route as ProtectedLedgersCustomerDepositsIdRouteImport } from './routes/_protected/ledgers/customer-deposits/$id'
import { Route as ProtectedLedgersBuysIdRouteImport } from './routes/_protected/ledgers/buys/$id'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedZonesRoute = ProtectedZonesRouteImport.update({
  id: '/zones',
  path: '/zones',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPaymentMethodsRoute = ProtectedPaymentMethodsRouteImport.update({
  id: '/payment-methods',
  path: '/payment-methods',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCategoriesRoute = ProtectedCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWarehousesIndexRoute =
  ProtectedWarehousesIndexRouteImport.update({
    id: '/warehouses/',
    path: '/warehouses/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedUsersIndexRoute = ProtectedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTenantsIndexRoute = ProtectedTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSuppliersIndexRoute = ProtectedSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSellsIndexRoute = ProtectedSellsIndexRouteImport.update({
  id: '/sells/',
  path: '/sells/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedIncomesIndexRoute = ProtectedIncomesIndexRouteImport.update({
  id: '/incomes/',
  path: '/incomes/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedExpensesIndexRoute = ProtectedExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedClientsIndexRoute = ProtectedClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCashRegisterIndexRoute =
  ProtectedCashRegisterIndexRouteImport.update({
    id: '/cash-register/',
    path: '/cash-register/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedBuysIndexRoute = ProtectedBuysIndexRouteImport.update({
  id: '/buys/',
  path: '/buys/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedBalancesIndexRoute = ProtectedBalancesIndexRouteImport.update({
  id: '/balances/',
  path: '/balances/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedArticlesIndexRoute = ProtectedArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAccountsIndexRoute = ProtectedAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWarehousesIdRoute = ProtectedWarehousesIdRouteImport.update({
  id: '/warehouses/$id',
  path: '/warehouses/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedUsersIdRoute = ProtectedUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTenantsIdRoute = ProtectedTenantsIdRouteImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSuppliersIdRoute = ProtectedSuppliersIdRouteImport.update({
  id: '/suppliers/$id',
  path: '/suppliers/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSellsCreateRoute = ProtectedSellsCreateRouteImport.update({
  id: '/sells/create',
  path: '/sells/create',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSellsIdRoute = ProtectedSellsIdRouteImport.update({
  id: '/sells/$id',
  path: '/sells/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedIncomesIdRoute = ProtectedIncomesIdRouteImport.update({
  id: '/incomes/$id',
  path: '/incomes/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedExpensesIdRoute = ProtectedExpensesIdRouteImport.update({
  id: '/expenses/$id',
  path: '/expenses/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedClientsIdRoute = ProtectedClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedBuysCreateRoute = ProtectedBuysCreateRouteImport.update({
  id: '/buys/create',
  path: '/buys/create',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedBuysIdRoute = ProtectedBuysIdRouteImport.update({
  id: '/buys/$id',
  path: '/buys/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedArticlesIdRoute = ProtectedArticlesIdRouteImport.update({
  id: '/articles/$id',
  path: '/articles/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAccountsIdRoute = ProtectedAccountsIdRouteImport.update({
  id: '/accounts/$id',
  path: '/accounts/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedLedgersSellsIndexRoute =
  ProtectedLedgersSellsIndexRouteImport.update({
    id: '/ledgers/sells/',
    path: '/ledgers/sells/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedLedgersCustomerDepositsIndexRoute =
  ProtectedLedgersCustomerDepositsIndexRouteImport.update({
    id: '/ledgers/customer-deposits/',
    path: '/ledgers/customer-deposits/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedLedgersBuysIndexRoute =
  ProtectedLedgersBuysIndexRouteImport.update({
    id: '/ledgers/buys/',
    path: '/ledgers/buys/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedLedgersSellsIdRoute = ProtectedLedgersSellsIdRouteImport.update({
  id: '/ledgers/sells/$id',
  path: '/ledgers/sells/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedLedgersCustomerDepositsIdRoute =
  ProtectedLedgersCustomerDepositsIdRouteImport.update({
    id: '/ledgers/customer-deposits/$id',
    path: '/ledgers/customer-deposits/$id',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedLedgersBuysIdRoute = ProtectedLedgersBuysIdRouteImport.update({
  id: '/ledgers/buys/$id',
  path: '/ledgers/buys/$id',
  getParentRoute: () => ProtectedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/categories': typeof ProtectedCategoriesRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/payment-methods': typeof ProtectedPaymentMethodsRoute
  '/zones': typeof ProtectedZonesRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/accounts/$id': typeof ProtectedAccountsIdRoute
  '/articles/$id': typeof ProtectedArticlesIdRoute
  '/buys/$id': typeof ProtectedBuysIdRoute
  '/buys/create': typeof ProtectedBuysCreateRoute
  '/clients/$id': typeof ProtectedClientsIdRoute
  '/expenses/$id': typeof ProtectedExpensesIdRoute
  '/incomes/$id': typeof ProtectedIncomesIdRoute
  '/sells/$id': typeof ProtectedSellsIdRoute
  '/sells/create': typeof ProtectedSellsCreateRoute
  '/suppliers/$id': typeof ProtectedSuppliersIdRoute
  '/tenants/$id': typeof ProtectedTenantsIdRoute
  '/users/$id': typeof ProtectedUsersIdRoute
  '/warehouses/$id': typeof ProtectedWarehousesIdRoute
  '/accounts': typeof ProtectedAccountsIndexRoute
  '/articles': typeof ProtectedArticlesIndexRoute
  '/balances': typeof ProtectedBalancesIndexRoute
  '/buys': typeof ProtectedBuysIndexRoute
  '/cash-register': typeof ProtectedCashRegisterIndexRoute
  '/clients': typeof ProtectedClientsIndexRoute
  '/expenses': typeof ProtectedExpensesIndexRoute
  '/incomes': typeof ProtectedIncomesIndexRoute
  '/sells': typeof ProtectedSellsIndexRoute
  '/suppliers': typeof ProtectedSuppliersIndexRoute
  '/tenants': typeof ProtectedTenantsIndexRoute
  '/users': typeof ProtectedUsersIndexRoute
  '/warehouses': typeof ProtectedWarehousesIndexRoute
  '/ledgers/buys/$id': typeof ProtectedLedgersBuysIdRoute
  '/ledgers/customer-deposits/$id': typeof ProtectedLedgersCustomerDepositsIdRoute
  '/ledgers/sells/$id': typeof ProtectedLedgersSellsIdRoute
  '/ledgers/buys': typeof ProtectedLedgersBuysIndexRoute
  '/ledgers/customer-deposits': typeof ProtectedLedgersCustomerDepositsIndexRoute
  '/ledgers/sells': typeof ProtectedLedgersSellsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/categories': typeof ProtectedCategoriesRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/payment-methods': typeof ProtectedPaymentMethodsRoute
  '/zones': typeof ProtectedZonesRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/accounts/$id': typeof ProtectedAccountsIdRoute
  '/articles/$id': typeof ProtectedArticlesIdRoute
  '/buys/$id': typeof ProtectedBuysIdRoute
  '/buys/create': typeof ProtectedBuysCreateRoute
  '/clients/$id': typeof ProtectedClientsIdRoute
  '/expenses/$id': typeof ProtectedExpensesIdRoute
  '/incomes/$id': typeof ProtectedIncomesIdRoute
  '/sells/$id': typeof ProtectedSellsIdRoute
  '/sells/create': typeof ProtectedSellsCreateRoute
  '/suppliers/$id': typeof ProtectedSuppliersIdRoute
  '/tenants/$id': typeof ProtectedTenantsIdRoute
  '/users/$id': typeof ProtectedUsersIdRoute
  '/warehouses/$id': typeof ProtectedWarehousesIdRoute
  '/accounts': typeof ProtectedAccountsIndexRoute
  '/articles': typeof ProtectedArticlesIndexRoute
  '/balances': typeof ProtectedBalancesIndexRoute
  '/buys': typeof ProtectedBuysIndexRoute
  '/cash-register': typeof ProtectedCashRegisterIndexRoute
  '/clients': typeof ProtectedClientsIndexRoute
  '/expenses': typeof ProtectedExpensesIndexRoute
  '/incomes': typeof ProtectedIncomesIndexRoute
  '/sells': typeof ProtectedSellsIndexRoute
  '/suppliers': typeof ProtectedSuppliersIndexRoute
  '/tenants': typeof ProtectedTenantsIndexRoute
  '/users': typeof ProtectedUsersIndexRoute
  '/warehouses': typeof ProtectedWarehousesIndexRoute
  '/ledgers/buys/$id': typeof ProtectedLedgersBuysIdRoute
  '/ledgers/customer-deposits/$id': typeof ProtectedLedgersCustomerDepositsIdRoute
  '/ledgers/sells/$id': typeof ProtectedLedgersSellsIdRoute
  '/ledgers/buys': typeof ProtectedLedgersBuysIndexRoute
  '/ledgers/customer-deposits': typeof ProtectedLedgersCustomerDepositsIndexRoute
  '/ledgers/sells': typeof ProtectedLedgersSellsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_protected/categories': typeof ProtectedCategoriesRoute
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/payment-methods': typeof ProtectedPaymentMethodsRoute
  '/_protected/zones': typeof ProtectedZonesRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_protected/accounts/$id': typeof ProtectedAccountsIdRoute
  '/_protected/articles/$id': typeof ProtectedArticlesIdRoute
  '/_protected/buys/$id': typeof ProtectedBuysIdRoute
  '/_protected/buys/create': typeof ProtectedBuysCreateRoute
  '/_protected/clients/$id': typeof ProtectedClientsIdRoute
  '/_protected/expenses/$id': typeof ProtectedExpensesIdRoute
  '/_protected/incomes/$id': typeof ProtectedIncomesIdRoute
  '/_protected/sells/$id': typeof ProtectedSellsIdRoute
  '/_protected/sells/create': typeof ProtectedSellsCreateRoute
  '/_protected/suppliers/$id': typeof ProtectedSuppliersIdRoute
  '/_protected/tenants/$id': typeof ProtectedTenantsIdRoute
  '/_protected/users/$id': typeof ProtectedUsersIdRoute
  '/_protected/warehouses/$id': typeof ProtectedWarehousesIdRoute
  '/_protected/accounts/': typeof ProtectedAccountsIndexRoute
  '/_protected/articles/': typeof ProtectedArticlesIndexRoute
  '/_protected/balances/': typeof ProtectedBalancesIndexRoute
  '/_protected/buys/': typeof ProtectedBuysIndexRoute
  '/_protected/cash-register/': typeof ProtectedCashRegisterIndexRoute
  '/_protected/clients/': typeof ProtectedClientsIndexRoute
  '/_protected/expenses/': typeof ProtectedExpensesIndexRoute
  '/_protected/incomes/': typeof ProtectedIncomesIndexRoute
  '/_protected/sells/': typeof ProtectedSellsIndexRoute
  '/_protected/suppliers/': typeof ProtectedSuppliersIndexRoute
  '/_protected/tenants/': typeof ProtectedTenantsIndexRoute
  '/_protected/users/': typeof ProtectedUsersIndexRoute
  '/_protected/warehouses/': typeof ProtectedWarehousesIndexRoute
  '/_protected/ledgers/buys/$id': typeof ProtectedLedgersBuysIdRoute
  '/_protected/ledgers/customer-deposits/$id': typeof ProtectedLedgersCustomerDepositsIdRoute
  '/_protected/ledgers/sells/$id': typeof ProtectedLedgersSellsIdRoute
  '/_protected/ledgers/buys/': typeof ProtectedLedgersBuysIndexRoute
  '/_protected/ledgers/customer-deposits/': typeof ProtectedLedgersCustomerDepositsIndexRoute
  '/_protected/ledgers/sells/': typeof ProtectedLedgersSellsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/categories'
    | '/dashboard'
    | '/payment-methods'
    | '/zones'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/accounts/$id'
    | '/articles/$id'
    | '/buys/$id'
    | '/buys/create'
    | '/clients/$id'
    | '/expenses/$id'
    | '/incomes/$id'
    | '/sells/$id'
    | '/sells/create'
    | '/suppliers/$id'
    | '/tenants/$id'
    | '/users/$id'
    | '/warehouses/$id'
    | '/accounts'
    | '/articles'
    | '/balances'
    | '/buys'
    | '/cash-register'
    | '/clients'
    | '/expenses'
    | '/incomes'
    | '/sells'
    | '/suppliers'
    | '/tenants'
    | '/users'
    | '/warehouses'
    | '/ledgers/buys/$id'
    | '/ledgers/customer-deposits/$id'
    | '/ledgers/sells/$id'
    | '/ledgers/buys'
    | '/ledgers/customer-deposits'
    | '/ledgers/sells'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/categories'
    | '/dashboard'
    | '/payment-methods'
    | '/zones'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/accounts/$id'
    | '/articles/$id'
    | '/buys/$id'
    | '/buys/create'
    | '/clients/$id'
    | '/expenses/$id'
    | '/incomes/$id'
    | '/sells/$id'
    | '/sells/create'
    | '/suppliers/$id'
    | '/tenants/$id'
    | '/users/$id'
    | '/warehouses/$id'
    | '/accounts'
    | '/articles'
    | '/balances'
    | '/buys'
    | '/cash-register'
    | '/clients'
    | '/expenses'
    | '/incomes'
    | '/sells'
    | '/suppliers'
    | '/tenants'
    | '/users'
    | '/warehouses'
    | '/ledgers/buys/$id'
    | '/ledgers/customer-deposits/$id'
    | '/ledgers/sells/$id'
    | '/ledgers/buys'
    | '/ledgers/customer-deposits'
    | '/ledgers/sells'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/_public'
    | '/_protected/categories'
    | '/_protected/dashboard'
    | '/_protected/payment-methods'
    | '/_protected/zones'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_protected/accounts/$id'
    | '/_protected/articles/$id'
    | '/_protected/buys/$id'
    | '/_protected/buys/create'
    | '/_protected/clients/$id'
    | '/_protected/expenses/$id'
    | '/_protected/incomes/$id'
    | '/_protected/sells/$id'
    | '/_protected/sells/create'
    | '/_protected/suppliers/$id'
    | '/_protected/tenants/$id'
    | '/_protected/users/$id'
    | '/_protected/warehouses/$id'
    | '/_protected/accounts/'
    | '/_protected/articles/'
    | '/_protected/balances/'
    | '/_protected/buys/'
    | '/_protected/cash-register/'
    | '/_protected/clients/'
    | '/_protected/expenses/'
    | '/_protected/incomes/'
    | '/_protected/sells/'
    | '/_protected/suppliers/'
    | '/_protected/tenants/'
    | '/_protected/users/'
    | '/_protected/warehouses/'
    | '/_protected/ledgers/buys/$id'
    | '/_protected/ledgers/customer-deposits/$id'
    | '/_protected/ledgers/sells/$id'
    | '/_protected/ledgers/buys/'
    | '/_protected/ledgers/customer-deposits/'
    | '/_protected/ledgers/sells/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/zones': {
      id: '/_protected/zones'
      path: '/zones'
      fullPath: '/zones'
      preLoaderRoute: typeof ProtectedZonesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/payment-methods': {
      id: '/_protected/payment-methods'
      path: '/payment-methods'
      fullPath: '/payment-methods'
      preLoaderRoute: typeof ProtectedPaymentMethodsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/categories': {
      id: '/_protected/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof ProtectedCategoriesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/warehouses/': {
      id: '/_protected/warehouses/'
      path: '/warehouses'
      fullPath: '/warehouses'
      preLoaderRoute: typeof ProtectedWarehousesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/users/': {
      id: '/_protected/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ProtectedUsersIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/tenants/': {
      id: '/_protected/tenants/'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof ProtectedTenantsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/suppliers/': {
      id: '/_protected/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof ProtectedSuppliersIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sells/': {
      id: '/_protected/sells/'
      path: '/sells'
      fullPath: '/sells'
      preLoaderRoute: typeof ProtectedSellsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/incomes/': {
      id: '/_protected/incomes/'
      path: '/incomes'
      fullPath: '/incomes'
      preLoaderRoute: typeof ProtectedIncomesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/expenses/': {
      id: '/_protected/expenses/'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof ProtectedExpensesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/clients/': {
      id: '/_protected/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ProtectedClientsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/cash-register/': {
      id: '/_protected/cash-register/'
      path: '/cash-register'
      fullPath: '/cash-register'
      preLoaderRoute: typeof ProtectedCashRegisterIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/buys/': {
      id: '/_protected/buys/'
      path: '/buys'
      fullPath: '/buys'
      preLoaderRoute: typeof ProtectedBuysIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/balances/': {
      id: '/_protected/balances/'
      path: '/balances'
      fullPath: '/balances'
      preLoaderRoute: typeof ProtectedBalancesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/articles/': {
      id: '/_protected/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof ProtectedArticlesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/': {
      id: '/_protected/accounts/'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof ProtectedAccountsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/warehouses/$id': {
      id: '/_protected/warehouses/$id'
      path: '/warehouses/$id'
      fullPath: '/warehouses/$id'
      preLoaderRoute: typeof ProtectedWarehousesIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/users/$id': {
      id: '/_protected/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof ProtectedUsersIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/tenants/$id': {
      id: '/_protected/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/tenants/$id'
      preLoaderRoute: typeof ProtectedTenantsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/suppliers/$id': {
      id: '/_protected/suppliers/$id'
      path: '/suppliers/$id'
      fullPath: '/suppliers/$id'
      preLoaderRoute: typeof ProtectedSuppliersIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sells/create': {
      id: '/_protected/sells/create'
      path: '/sells/create'
      fullPath: '/sells/create'
      preLoaderRoute: typeof ProtectedSellsCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sells/$id': {
      id: '/_protected/sells/$id'
      path: '/sells/$id'
      fullPath: '/sells/$id'
      preLoaderRoute: typeof ProtectedSellsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/incomes/$id': {
      id: '/_protected/incomes/$id'
      path: '/incomes/$id'
      fullPath: '/incomes/$id'
      preLoaderRoute: typeof ProtectedIncomesIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/expenses/$id': {
      id: '/_protected/expenses/$id'
      path: '/expenses/$id'
      fullPath: '/expenses/$id'
      preLoaderRoute: typeof ProtectedExpensesIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/clients/$id': {
      id: '/_protected/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof ProtectedClientsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/buys/create': {
      id: '/_protected/buys/create'
      path: '/buys/create'
      fullPath: '/buys/create'
      preLoaderRoute: typeof ProtectedBuysCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/buys/$id': {
      id: '/_protected/buys/$id'
      path: '/buys/$id'
      fullPath: '/buys/$id'
      preLoaderRoute: typeof ProtectedBuysIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/articles/$id': {
      id: '/_protected/articles/$id'
      path: '/articles/$id'
      fullPath: '/articles/$id'
      preLoaderRoute: typeof ProtectedArticlesIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/accounts/$id': {
      id: '/_protected/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof ProtectedAccountsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ledgers/sells/': {
      id: '/_protected/ledgers/sells/'
      path: '/ledgers/sells'
      fullPath: '/ledgers/sells'
      preLoaderRoute: typeof ProtectedLedgersSellsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ledgers/customer-deposits/': {
      id: '/_protected/ledgers/customer-deposits/'
      path: '/ledgers/customer-deposits'
      fullPath: '/ledgers/customer-deposits'
      preLoaderRoute: typeof ProtectedLedgersCustomerDepositsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ledgers/buys/': {
      id: '/_protected/ledgers/buys/'
      path: '/ledgers/buys'
      fullPath: '/ledgers/buys'
      preLoaderRoute: typeof ProtectedLedgersBuysIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ledgers/sells/$id': {
      id: '/_protected/ledgers/sells/$id'
      path: '/ledgers/sells/$id'
      fullPath: '/ledgers/sells/$id'
      preLoaderRoute: typeof ProtectedLedgersSellsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ledgers/customer-deposits/$id': {
      id: '/_protected/ledgers/customer-deposits/$id'
      path: '/ledgers/customer-deposits/$id'
      fullPath: '/ledgers/customer-deposits/$id'
      preLoaderRoute: typeof ProtectedLedgersCustomerDepositsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/ledgers/buys/$id': {
      id: '/_protected/ledgers/buys/$id'
      path: '/ledgers/buys/$id'
      fullPath: '/ledgers/buys/$id'
      preLoaderRoute: typeof ProtectedLedgersBuysIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedCategoriesRoute: typeof ProtectedCategoriesRoute
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedPaymentMethodsRoute: typeof ProtectedPaymentMethodsRoute
  ProtectedZonesRoute: typeof ProtectedZonesRoute
  ProtectedAccountsIdRoute: typeof ProtectedAccountsIdRoute
  ProtectedArticlesIdRoute: typeof ProtectedArticlesIdRoute
  ProtectedBuysIdRoute: typeof ProtectedBuysIdRoute
  ProtectedBuysCreateRoute: typeof ProtectedBuysCreateRoute
  ProtectedClientsIdRoute: typeof ProtectedClientsIdRoute
  ProtectedExpensesIdRoute: typeof ProtectedExpensesIdRoute
  ProtectedIncomesIdRoute: typeof ProtectedIncomesIdRoute
  ProtectedSellsIdRoute: typeof ProtectedSellsIdRoute
  ProtectedSellsCreateRoute: typeof ProtectedSellsCreateRoute
  ProtectedSuppliersIdRoute: typeof ProtectedSuppliersIdRoute
  ProtectedTenantsIdRoute: typeof ProtectedTenantsIdRoute
  ProtectedUsersIdRoute: typeof ProtectedUsersIdRoute
  ProtectedWarehousesIdRoute: typeof ProtectedWarehousesIdRoute
  ProtectedAccountsIndexRoute: typeof ProtectedAccountsIndexRoute
  ProtectedArticlesIndexRoute: typeof ProtectedArticlesIndexRoute
  ProtectedBalancesIndexRoute: typeof ProtectedBalancesIndexRoute
  ProtectedBuysIndexRoute: typeof ProtectedBuysIndexRoute
  ProtectedCashRegisterIndexRoute: typeof ProtectedCashRegisterIndexRoute
  ProtectedClientsIndexRoute: typeof ProtectedClientsIndexRoute
  ProtectedExpensesIndexRoute: typeof ProtectedExpensesIndexRoute
  ProtectedIncomesIndexRoute: typeof ProtectedIncomesIndexRoute
  ProtectedSellsIndexRoute: typeof ProtectedSellsIndexRoute
  ProtectedSuppliersIndexRoute: typeof ProtectedSuppliersIndexRoute
  ProtectedTenantsIndexRoute: typeof ProtectedTenantsIndexRoute
  ProtectedUsersIndexRoute: typeof ProtectedUsersIndexRoute
  ProtectedWarehousesIndexRoute: typeof ProtectedWarehousesIndexRoute
  ProtectedLedgersBuysIdRoute: typeof ProtectedLedgersBuysIdRoute
  ProtectedLedgersCustomerDepositsIdRoute: typeof ProtectedLedgersCustomerDepositsIdRoute
  ProtectedLedgersSellsIdRoute: typeof ProtectedLedgersSellsIdRoute
  ProtectedLedgersBuysIndexRoute: typeof ProtectedLedgersBuysIndexRoute
  ProtectedLedgersCustomerDepositsIndexRoute: typeof ProtectedLedgersCustomerDepositsIndexRoute
  ProtectedLedgersSellsIndexRoute: typeof ProtectedLedgersSellsIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedCategoriesRoute: ProtectedCategoriesRoute,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedPaymentMethodsRoute: ProtectedPaymentMethodsRoute,
  ProtectedZonesRoute: ProtectedZonesRoute,
  ProtectedAccountsIdRoute: ProtectedAccountsIdRoute,
  ProtectedArticlesIdRoute: ProtectedArticlesIdRoute,
  ProtectedBuysIdRoute: ProtectedBuysIdRoute,
  ProtectedBuysCreateRoute: ProtectedBuysCreateRoute,
  ProtectedClientsIdRoute: ProtectedClientsIdRoute,
  ProtectedExpensesIdRoute: ProtectedExpensesIdRoute,
  ProtectedIncomesIdRoute: ProtectedIncomesIdRoute,
  ProtectedSellsIdRoute: ProtectedSellsIdRoute,
  ProtectedSellsCreateRoute: ProtectedSellsCreateRoute,
  ProtectedSuppliersIdRoute: ProtectedSuppliersIdRoute,
  ProtectedTenantsIdRoute: ProtectedTenantsIdRoute,
  ProtectedUsersIdRoute: ProtectedUsersIdRoute,
  ProtectedWarehousesIdRoute: ProtectedWarehousesIdRoute,
  ProtectedAccountsIndexRoute: ProtectedAccountsIndexRoute,
  ProtectedArticlesIndexRoute: ProtectedArticlesIndexRoute,
  ProtectedBalancesIndexRoute: ProtectedBalancesIndexRoute,
  ProtectedBuysIndexRoute: ProtectedBuysIndexRoute,
  ProtectedCashRegisterIndexRoute: ProtectedCashRegisterIndexRoute,
  ProtectedClientsIndexRoute: ProtectedClientsIndexRoute,
  ProtectedExpensesIndexRoute: ProtectedExpensesIndexRoute,
  ProtectedIncomesIndexRoute: ProtectedIncomesIndexRoute,
  ProtectedSellsIndexRoute: ProtectedSellsIndexRoute,
  ProtectedSuppliersIndexRoute: ProtectedSuppliersIndexRoute,
  ProtectedTenantsIndexRoute: ProtectedTenantsIndexRoute,
  ProtectedUsersIndexRoute: ProtectedUsersIndexRoute,
  ProtectedWarehousesIndexRoute: ProtectedWarehousesIndexRoute,
  ProtectedLedgersBuysIdRoute: ProtectedLedgersBuysIdRoute,
  ProtectedLedgersCustomerDepositsIdRoute:
    ProtectedLedgersCustomerDepositsIdRoute,
  ProtectedLedgersSellsIdRoute: ProtectedLedgersSellsIdRoute,
  ProtectedLedgersBuysIndexRoute: ProtectedLedgersBuysIndexRoute,
  ProtectedLedgersCustomerDepositsIndexRoute:
    ProtectedLedgersCustomerDepositsIndexRoute,
  ProtectedLedgersSellsIndexRoute: ProtectedLedgersSellsIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
